import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import MediaQuery from './MediaQuery';
import ClientProvider from './client';
export default createDemo(import.meta.url, MediaQuery, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/customization/breakpoints/demos/media-query/MediaQuery.tsx",
    "fileName": "MediaQuery.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import { styled } from '@mui/material/styles';\nimport Typography from '@mui/material/Typography';\nimport { red, green, blue } from '@mui/material/colors';\n\nconst Root = styled('div')(({ theme }) => ({\n  padding: theme.spacing(1),\n  [theme.breakpoints.down('md')]: {\n    backgroundColor: red[500],\n  },\n  [theme.breakpoints.up('md')]: {\n    backgroundColor: blue[500],\n  },\n  [theme.breakpoints.up('lg')]: {\n    backgroundColor: green[500],\n  },\n}));\n\nexport default function MediaQuery() {\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 2,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <Root>\n      <Typography>down(md): red</Typography>\n      <Typography>up(md): blue</Typography>\n      <Typography>up(lg): green</Typography>\n    </Root>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 26,
        "focusedLines": 5,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import { styled } from '@mui/material/styles';\nimport Typography from '@mui/material/Typography';\nimport { red, green, blue } from '@mui/material/colors';\n\nconst Root = styled('div')(({ theme }) => ({\n  padding: theme.spacing(1),\n  [theme.breakpoints.down('md')]: {\n    backgroundColor: red[500],\n  },\n  [theme.breakpoints.up('md')]: {\n    backgroundColor: blue[500],\n  },\n  [theme.breakpoints.up('lg')]: {\n    backgroundColor: green[500],\n  },\n}));\n\nexport default function MediaQuery() {\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        "    <Root>\n      <Typography>down(md): red</Typography>\n      <Typography>up(md): blue</Typography>\n      <Typography>up(lg): green</Typography>\n    </Root>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 20
            },
            [
              "    <",
              [
                "span",
                "pl-c1 di-jsx",
                "Root"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 21
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Typography"
              ],
              ">down(md): red</",
              [
                "span",
                "pl-c1 di-jsx",
                "Typography"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 22
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Typography"
              ],
              ">up(md): blue</",
              [
                "span",
                "pl-c1 di-jsx",
                "Typography"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 23
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Typography"
              ],
              ">up(lg): green</",
              [
                "span",
                "pl-c1 di-jsx",
                "Typography"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 24
            },
            [
              "    </",
              [
                "span",
                "pl-c1 di-jsx",
                "Root"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 26,
    "focusedLines": 5,
    "collapsible": true,
    "externals": [
      "@mui/material/styles",
      "@mui/material/Typography",
      "@mui/material/colors"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
